// react
import React from 'react';

// third-party
import { Helmet } from 'react-helmet-async';

// data stubs
import theme from '../../data/theme';

export default function AccountPagePassword() {
    return (
        <div className="card">
            <Helmet>
                <title>{`Cambia Password — ${theme.name}`}</title>
            </Helmet>

            <div className="card-header">
                <h5>Cambia Password</h5>
            </div>
            <div className="card-divider" />
            <div className="card-body">
                <div className="row no-gutters">
                    <div className="col-12 col-lg-7 col-xl-6">
                        <div className="form-group">
                            <label htmlFor="password-current">Password Corrente</label>
                            <input
                                type="password"
                                className="form-control"
                                id="password-current"
                                placeholder="Password Corrente"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="password-new">Nuova Password</label>
                            <input
                                type="password"
                                className="form-control"
                                id="password-new"
                                placeholder="Nuova Password"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="password-confirm">Reinserisci Nuova Password</label>
                            <input
                                type="password"
                                className="form-control"
                                id="password-confirm"
                                placeholder="Reinserisci Nuova Password"
                            />
                        </div>

                        <div className="form-group mt-5 mb-0">
                            <button type="button" className="btn btn-primary">Cambia</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
